import React from "react";

const LandingPage = () => {
  const cacheBuster = React.useMemo(
  () => process.env.REACT_APP_BUILD_ID || String(Date.now()),
  []
);


  return (
    <div className="w-full min-h-screen flex flex-col bg-white">
      <iframe
        src={`/LandingPage.html?v=${cacheBuster}`}
        title="Landing Page"
        className="w-full min-h-screen border-0"
      />
    </div>
  );
};

export default LandingPage;


